import { Grid, Button as BaseButton, styled } from '@material-ui/core';
import { Typography } from 'components';
import { isFitanu, getCurrentFont } from 'config/theme';
import { colors } from 'config';

const BUTTON_HEIGHT = 50;
const BUTTON_WIDTH = 220;
const BUTTON_WIDTH_XS = 190;
const BUTTON_HEIGHT_XS = 42;
const PRODUCT_HEIGHT = 500;

const PRICE_COLOR = '#FEDC00';
const PRICE_TITLE_COLOR = '#212122';
const PRICE_SUBTITLE_COLOR = '#161522';
const FITANU_PRICE_COLOR = '#D10A3D';

export const Wrapper = styled(Grid)(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  flexWrap: 'nowrap',
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(2.5, 2.5, 5, 2.5),
  borderRadius: 15,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 2.5, 4, 2.5),
  },
}));

export const Content = styled(Grid)(({ theme }) => ({
  height: '100%',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: getCurrentFont('korolev'),
  fontSize: 23,
  lineHeight: '25px',
  fontWeight: 'bold',
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  [theme.breakpoints.down('md')]: {
    fontSize: 25,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '23px',
  },
}));

export const Price = styled(Typography)(({ theme }) => ({
  fontFamily: getCurrentFont('korolev'),
  fontSize: 37,
  lineHeight: '43px',
  fontWeight: 'bold',
  letterSpacing: 0.25,
  textTransform: 'uppercase',
  color: isFitanu() ? theme.palette.common.white : PRICE_TITLE_COLOR,
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 22,
    lineHeight: '25px',
  },
}));

export const OldPrice = styled(Typography)(({ theme }) => ({
  fontSize: 22,
  lineHeight: '24px',
  letterSpacing: 0.66,
  fontWeight: isFitanu() ? 600 : 500,
  whiteSpace: 'nowrap',
  position: 'relative',
  color: theme.palette.text.primary,
  '&::after': {
    position: 'absolute',
    left: 0,
    top: '48%',
    height: 2,
    background: theme.palette.common.black,
    content: '""',
    width: '100%',
    display: 'block',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 22,
    lineHeight: '25px',
  },
}));

export const OldPriceWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  marginLeft: theme.spacing(2.5),
  // textDecoration: 'line-through',
  flexWrap: 'wrap',
  alignItems: 'center',
  position: 'relative',
}));

export const PriceWrapper = styled(Grid)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  borderRadius: isFitanu() ? 0 : 8,
  backgroundColor: isFitanu() ? FITANU_PRICE_COLOR : PRICE_COLOR,
  boxSizing: 'border-box',
  padding: theme.spacing(1.25, 2.5),
  flexWrap: 'wrap',
  margin: theme.spacing(1, 0),
}));

export const BestPriceTitle = styled(Typography)(({ theme }) => ({
  color: isFitanu() ? theme.palette.common.white : PRICE_SUBTITLE_COLOR,
  fontSize: 15,
  lineHeight: '17px',
  letterSpacing: 0.05,
  fontWeight: isFitanu() ? 500 : 400,
  marginRight: theme.spacing(1.5),
  '& span': {
    fontWeight: 'bold',
    display: 'block',
  },
}));

export const OldPriceTitle = styled(BestPriceTitle)(({ theme }) => ({
  marginRight: theme.spacing(),
  color: PRICE_SUBTITLE_COLOR,
  fontWeight: isFitanu() ? 500 : 400,
  position: 'relative',
  '& span': {
    display: 'inline',
    fontWeight: 'normal',
  },
}));

export const Button = styled(BaseButton)(({ theme }) => ({
  width: BUTTON_WIDTH,
  height: BUTTON_HEIGHT,
  minHeight: BUTTON_HEIGHT,
  boxSizing: 'border-box',
  fontFamily: getCurrentFont(),
  textTransform: isFitanu() ? 'uppercase' : 'none',
  borderRadius: isFitanu() ? 0 : 5,
  backgroundColor: colors.landing.text.secondary,
  color: theme.palette.common.white,
  fontSize: 17,
  lineHeight: '23px',
  marginTop: theme.spacing(3),
  letterSpacing: 0.11,
  '&:hover': {
    backgroundColor: colors.landing.text.secondary,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: BUTTON_WIDTH,
  },
  [theme.breakpoints.down('xs')]: {
    height: BUTTON_HEIGHT_XS,
    width: '100%',
    maxWidth: BUTTON_WIDTH_XS,
    fontSize: 15,
    fontWeight: 400,
  },
}));

export const Thumbnail = styled('div')(({ theme }) => ({
  height: PRODUCT_HEIGHT * 0.45,
  marginBottom: theme.spacing(3),
  width: '100%',
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    height: PRODUCT_HEIGHT * 0.3,
  },
}));

export const Logo = styled('div')(({ theme }) => ({
  height: 45,
  marginBottom: theme.spacing(0.5),
  marginRight: theme.spacing(1),
  width: '100%',
  backgroundSize: 'contain',
  backgroundPosition: 'right',
  backgroundRepeat: 'no-repeat',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    height: 45,
  },
}));

export const TitleWrapper = styled('div')(({ theme }) => ({
  display: '-webkit-box',
  marginLeft: theme.spacing(2.5),
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
}));
